import PropTypes from "prop-types"
import {getPreviousWeekdayReferenceDate} from "./validation-utils"

export const CALCULATION_STATUS = Object.freeze({
    IDLE: "idle",
    LOADING: "loading",
    SUCCESS: "success",
    ERROR: "error",
})

const EMPTY_RESULTS = Object.freeze({
    puparCalculado: null,
    deltaPupar: null,
    variacaoPercentualPupar: null,
    pumtmCalculado: null,
    deltaPumtm: null,
    variacaoPercentualPumtm: null,
    spreadEmissao: null,
    prazoMedioEmissao: null,
    percentualPupar: null,
    durationModificada: null,
    durationMacaulay: null,
})

const EMPTY_PREMIO = Object.freeze({
    aplicavel: false,
    valor: null,
    memoria: [],
})

const getMemoryRows = (rows) => (Array.isArray(rows) ? rows : [])

const normalizePremio = (premio) => {
    const source = premio ?? {}

    return {
        ...EMPTY_PREMIO,
        ...source,
        aplicavel: Boolean(source.aplicavel),
        memoria: getMemoryRows(source.memoria),
    }
}

const normalizeMemories = (memories) => {
    const source = memories ?? {}

    return {
        ...source,
        pupar: getMemoryRows(source.pupar),
        pumtm: getMemoryRows(source.pumtm),
        fatorCorrecao: getMemoryRows(source.fatorCorrecao),
    }
}

export const createInitialValidationParameters = () => ({
    dataReferencia: getPreviousWeekdayReferenceDate(),
    puparReferencia: "",
    pumtmReferencia: "",
    spreadCredito: "",
})

export const getValidationViewModel = (viewModel) => {
    const source = viewModel ?? {}

    return {
        results: {...EMPTY_RESULTS, ...(source.results || {})},
        premios: {
            recompra: normalizePremio(source.premios?.recompra),
            conversibilidade: normalizePremio(source.premios?.conversibilidade),
        },
        memories: normalizeMemories(source.memories),
    }
}

const memoryRowsPropType = PropTypes.arrayOf(PropTypes.object)

export const validationResultsPropType = PropTypes.shape({
    puparCalculado: PropTypes.any,
    deltaPupar: PropTypes.any,
    variacaoPercentualPupar: PropTypes.any,
    pumtmCalculado: PropTypes.any,
    deltaPumtm: PropTypes.any,
    variacaoPercentualPumtm: PropTypes.any,
    spreadEmissao: PropTypes.any,
    prazoMedioEmissao: PropTypes.any,
    percentualPupar: PropTypes.any,
    durationModificada: PropTypes.any,
    durationMacaulay: PropTypes.any,
})

export const validationPremioPropType = PropTypes.shape({
    aplicavel: PropTypes.bool,
    valor: PropTypes.any,
    memoria: memoryRowsPropType,
})

export const validationPremiosPropType = PropTypes.shape({
    recompra: validationPremioPropType,
    conversibilidade: validationPremioPropType,
})

export const validationMemoriesPropType = PropTypes.shape({
    pupar: memoryRowsPropType,
    pumtm: memoryRowsPropType,
    fatorCorrecao: memoryRowsPropType,
})

const normalizedValidationPremioPropType = PropTypes.shape({
    aplicavel: PropTypes.bool.isRequired,
    valor: PropTypes.any,
    memoria: memoryRowsPropType.isRequired,
})

export const normalizedValidationPremiosPropType = PropTypes.shape({
    recompra: normalizedValidationPremioPropType.isRequired,
    conversibilidade: normalizedValidationPremioPropType.isRequired,
})

export const normalizedValidationMemoriesPropType = PropTypes.shape({
    pupar: memoryRowsPropType.isRequired,
    pumtm: memoryRowsPropType.isRequired,
    fatorCorrecao: memoryRowsPropType.isRequired,
})

export const validationViewModelPropType = PropTypes.shape({
    results: validationResultsPropType,
    premios: validationPremiosPropType,
    memories: validationMemoriesPropType,
})

export const validationContextPropType = PropTypes.shape({
    cetip: PropTypes.string,
    versaoDocumento: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    idCaracteristica: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    caracteristica: PropTypes.shape({
        ID: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        CETIP: PropTypes.string,
        VersaoDocumento: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
})
